module.exports = __webpack_public_path__ + "pattern1.ea2316224d45899c59bc.png";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/PROD-mufit-web/src/assets/images/pattern1.png
// module id = ../../../../../src/assets/images/pattern1.png
// module chunks = styles